/**
 * Labstep
 */

import type { Filter } from './types';

export const isActive = (
  searchParams: Record<string, unknown>,
  params?: Record<string, unknown>,
  postFilterValues?: Filter['postFilterValues'],
): boolean => {
  if (postFilterValues) {
    const [postFilter, values] = postFilterValues;
    return !!postFilter.getNodeInParams(searchParams, values);
  }
  if (params) {
    if (params.tag_id) {
      const activeTags = searchParams.tag_id
        ? (searchParams.tag_id as string).split(',')
        : [];
      return activeTags.includes(params.tag_id as string);
    }
    return Object.keys(params).reduce((result, key) => {
      return result && searchParams[key] === params[key];
    }, true);
  }
  return false;
};
